export const BRANDING_UPDATED_EVENT = "nco:branding-updated";

export function notifyBrandingUpdated() {
    window.dispatchEvent(new CustomEvent(BRANDING_UPDATED_EVENT));
}
